import React from "react";
import "./design.css";

function HalfPageDesign({ innerDesign, landingImage }) {
  return (
    <>
      <div
        className="bg-img-105"
        style={{
          backgroundImage: `url('${landingImage}')`,
        }}
      ></div>
      <div
        className="container "
        style={{ fontFamily: "font-family: 'Montserrat', sans-serif;" }}
      >
        <div className="row">
          <div className="col-md-5 p-5 bg-color mt-5">{innerDesign}</div>
        </div>
      </div>
    </>
  );
}
export default HalfPageDesign;
